import EnumType from "@/app/shared/EnumType.js";

const values = {
  Scoop: 0, 
  Truck: 1
};

export default EnumType.generate(values, "GradeControl.EquipmentType.");